module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Polizia-CL.50b90714.svg";